import { FormField, Input } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { isValidUrl } from "./../../_shared/link/is-valid-url";
const LinkInput = ({
  value,
  onChange,
  placeholder,
  dataHook,
  inputRef,
  onBlur,
  allowTelLink,
  labelEnabled = true,
  size = "medium"
}) => {
  const [state, setState] = useState(
    () => value && !isValidUrl(value, { allowTelLink }) ? "ERROR" : "OK"
  );
  const { t } = useContext(RicosContext);
  const handleInputChange = (event) => {
    const value2 = event.target.value;
    setState("OK");
    onChange(value2, "OK");
  };
  const handleBlur = () => {
    if (value && !isValidUrl(value, { allowTelLink })) {
      setState("ERROR");
    }
    const status = value && !isValidUrl(value, { allowTelLink }) ? "ERROR" : "OK";
    setState(status);
    onBlur?.({ url: value }, status);
  };
  return /* @__PURE__ */ React.createElement(
    FormField,
    {
      status: state === "ERROR" ? "error" : void 0,
      statusMessage: state === "ERROR" ? t("LinkPanel_ErrorTooltip") : void 0,
      label: labelEnabled ? t("GalleryImageSettings_Link_Label") : void 0
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        size,
        inputRef: (ref) => {
          if (inputRef) {
            inputRef.current = ref;
          }
        },
        type: "url",
        placeholder,
        value,
        onChange: handleInputChange,
        dataHook,
        onBlur: handleBlur
      }
    )
  );
};
export {
  LinkInput
};
//# sourceMappingURL=link-input.js.map
